import { categories } from "@/mocks/contest";

const accents = [
  { bg: "bg-primary-100", text: "text-primary-700", icon: "ri-trophy-line" },
  { bg: "bg-accent-100", text: "text-accent-800", icon: "ri-alarm-warning-line" },
  { bg: "bg-secondary-100", text: "text-secondary-900", icon: "ri-user-heart-line" },
  { bg: "bg-primary-50", text: "text-primary-600", icon: "ri-emotion-normal-line" },
  { bg: "bg-accent-50", text: "text-accent-700", icon: "ri-plant-line" },
];

export default function DailyHub() {
  return (
    <section id="daily" className="scroll-mt-20 bg-background-50 pb-4 pt-14 md:pt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="flex items-center gap-2 text-sm font-bold tracking-wide text-primary-600">
              <i className="ri-video-line" />
              栏目直通车
            </span>
            <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
              五大栏目，今日都有什么好戏
            </h2>
          </div>
          <a
            href="#rank"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700 transition hover:text-primary-800"
          >
            先看看谁登顶热榜
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((cat, i) => {
            const a = accents[i % accents.length];
            return (
              <a
                key={cat.key}
                href={`#${cat.key}`}
                className="group relative overflow-hidden rounded-3xl border border-background-200 bg-background-50 p-5 transition hover:-translate-y-1"
              >
                <img
                  src={cat.cover}
                  alt={`${cat.name} 栏目封面`}
                  className="h-28 w-full rounded-2xl object-cover object-top"
                />
                <span
                  className={`mt-4 flex h-9 w-9 items-center justify-center rounded-xl ${a.bg} ${a.text}`}
                >
                  <i className={`${a.icon} text-lg`} />
                </span>
                <h3 className="mt-3 text-base font-bold text-foreground-900 group-hover:text-primary-700">
                  {cat.short}
                </h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                  去围观
                  <i className="ri-arrow-right-line transition group-hover:translate-x-1" />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}